//JavaScript Document
import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import App from "../container/index/app";
import HomePage from "../container/index/homepage";
import NotifyDetail from "../container/index/notifyDetail";
import NotifyList from "../container/index/notifyList";
const homeRef = React.createRef();
ReactDOM.render(
  <Router>
    <App homeRef={homeRef}>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => <HomePage {...props} ref={homeRef} />}
        ></Route>
        <Route
          path="/index"
          render={(props) => <HomePage {...props} ref={homeRef} />}
        />
        <Route path="/notifyDetail/:url" component={NotifyDetail} />
        <Route path="/notifyList" component={NotifyList} />
      </Switch>
    </App>
  </Router>,
  document.getElementById("root")
);
